import { convertToHash } from '../convertToHash';
import { isInRealtimeTemplates } from './isInRealtimeTemplates';

export const toRealtimeTemplateHash = (filters?: string) => {
  if (filters && isInRealtimeTemplates(filters)) {
    return convertToHash(filters);
  }
  return undefined;
};
